/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { StickySeverity } from "./StickySeverity";
import {
  StickySeverityFromJSON,
  StickySeverityFromJSONTyped,
  StickySeverityToJSON,
  StickySeverityToJSONTyped,
} from "./StickySeverity";
import type { StickyEntityType } from "./StickyEntityType";
import {
  StickyEntityTypeFromJSON,
  StickyEntityTypeFromJSONTyped,
  StickyEntityTypeToJSON,
  StickyEntityTypeToJSONTyped,
} from "./StickyEntityType";
import type { StickyCategory } from "./StickyCategory";
import {
  StickyCategoryFromJSON,
  StickyCategoryFromJSONTyped,
  StickyCategoryToJSON,
  StickyCategoryToJSONTyped,
} from "./StickyCategory";

/**
 *
 * @export
 * @interface CreateStickyRequest
 */
export interface CreateStickyRequest {
  /**
   *
   * @type {StickyEntityType}
   * @memberof CreateStickyRequest
   */
  entityType: StickyEntityType;
  /**
   *
   * @type {string}
   * @memberof CreateStickyRequest
   */
  entityId: string;
  /**
   *
   * @type {string}
   * @memberof CreateStickyRequest
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateStickyRequest
   */
  description?: string | null;
  /**
   *
   * @type {StickyCategory}
   * @memberof CreateStickyRequest
   */
  category?: StickyCategory | null;
  /**
   *
   * @type {StickySeverity}
   * @memberof CreateStickyRequest
   */
  severity?: StickySeverity | null;
}

/**
 * Check if a given object implements the CreateStickyRequest interface.
 */
export function instanceOfCreateStickyRequest(
  value: object,
): value is CreateStickyRequest {
  if (!("entityType" in value) || value["entityType"] === undefined)
    return false;
  if (!("entityId" in value) || value["entityId"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  return true;
}

export function CreateStickyRequestFromJSON(json: any): CreateStickyRequest {
  return CreateStickyRequestFromJSONTyped(json, false);
}

export function CreateStickyRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateStickyRequest {
  if (json == null) {
    return json;
  }
  return {
    entityType: StickyEntityTypeFromJSON(json["entityType"]),
    entityId: json["entityId"],
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    category:
      json["category"] == null
        ? undefined
        : StickyCategoryFromJSON(json["category"]),
    severity:
      json["severity"] == null
        ? undefined
        : StickySeverityFromJSON(json["severity"]),
  };
}

export function CreateStickyRequestToJSON(json: any): CreateStickyRequest {
  return CreateStickyRequestToJSONTyped(json, false);
}

export function CreateStickyRequestToJSONTyped(
  value?: CreateStickyRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    entityType: StickyEntityTypeToJSON(value["entityType"]),
    entityId: value["entityId"],
    title: value["title"],
    description: value["description"],
    category: StickyCategoryToJSON(value["category"]),
    severity: StickySeverityToJSON(value["severity"]),
  };
}
